import Banner from 'componentes/Banner'
import SobreMim from 'componentes/SobreMim'
import { useEffect, useState } from 'react'
import styles from './Apresentacao.module.css'
import { AiFillGithub, AiFillLinkedin } from 'react-icons/ai';
import { BsFiletypePdf } from 'react-icons/bs';

export default function Apresentacao() {

    return (
        <section>
            <div className={styles.apresentacao}>
                <div className={styles.box}>
                    <img src="http://github.com/brunobahy.png" alt="Foto de Bruno Bahy" className={styles.apresentacao__foto} />
                    <div className={styles.info}>
                        <h2 className={styles.titulo}>Bruno Bahy</h2>
                        <p className={styles.subtitulo}>Front-end</p>
                        <p className={styles.texto}>conheça meu portfólio virtual</p>

                    </div>
                </div>
                <ul className={styles.lista__botoes}>
                    <li className={styles.item}>
                        <a className={styles.botao} href="/assets/curriculo.pdf" download={"curriculo.pdf"}> <BsFiletypePdf size={25} />Curriculo</a>
                        <img className={styles.imagem} src="assets/imgs/curriculo.png" alt="" />
                    </li>
                    <li className={styles.item}>
                        <a className={styles.botao} href="https://www.linkedin.com/in/bruno-bahy/"><AiFillLinkedin size={25} />Linkedin</a>
                        <img className={styles.imagem} src="assets/imgs/linkedin.png" alt="" />
                    </li>
                    <li className={styles.item}>
                        <a className={styles.botao} href="https://github.com/Brunobahy"> <AiFillGithub size={25} /> GitHub</a>
                        <img className={styles.imagem} src="assets/imgs/github.png" alt="" />

                    </li>
                </ul>
            </div>
        </section>
    )
}
